export default __webpack_public_path__ + "static/media/clean_couch.e3cde494.png";